import { useMutation } from '@tanstack/react-query';
import { deleteContactPhone } from '../../services/fn-api/User';

export const useDeleteContactPhoneDetails = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      return deleteContactPhone(id);
    },
  });
};
